export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.19-1437.21",
  commitId: "1715c695512071d87deb7878b2dbf779c8be3696",
  commitTime: "2026-10-19T14:37:21.000Z",
});
